module.exports = __webpack_public_path__ + "img/logo-shield.d96dd1b7.svg";